import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useCallback, useState } from 'react';
import { CorrelatedTemplate, CorrelatedTemplateUrl } from './utils';
import { useTranslation } from 'react-i18next';
import CorrelatedRules from './Rules/index';
import CorrelatedExpressions from './Expressions';
import { useNavigate } from 'react-router-dom';
import { handleNavigate } from '@Utils/common';

const CorrelatedRulesAndSignalsTemplate = (props: {
  tab: CorrelatedTemplate;
}) => {
  const { tab } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [index, setIndex] = useState<CorrelatedTemplate>(tab);

  const handleTabChange = useCallback(
    (index: CorrelatedTemplate) => {
      setIndex(index);
      handleNavigate(CorrelatedTemplateUrl[index]);
      navigate(CorrelatedTemplateUrl[index]);
    },
    [navigate]
  );

  return (
    <Tabs index={index} onChange={handleTabChange} flex="auto" px="4x">
      <TabList
        borderBottom="1px solid"
        borderBottomColor={colorStyle.divider}
        my="4x"
      >
        <Tab index={CorrelatedTemplate.rules}>
          {t('globalSetting.correlatedRules.tabs.rules')}
        </Tab>
        <Tab index={CorrelatedTemplate.expressions}>
          {t('globalSetting.correlatedRules.tabs.expressions')}
        </Tab>
      </TabList>
      <TabPanels display="flex" flexDirection="column" flex="auto">
        <TabPanel index={CorrelatedTemplate.rules}>
          {({ isSelected }: { isSelected: boolean }) =>
            isSelected && <CorrelatedRules />
          }
        </TabPanel>
        <TabPanel index={CorrelatedTemplate.expressions}>
          {({ isSelected }: { isSelected: boolean }) =>
            isSelected && <CorrelatedExpressions />
          }
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default CorrelatedRulesAndSignalsTemplate;
